import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2018 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Senior Software Engineer "
            subTitle="Zewst - (Dec 2023 - Jul 2024 - Present)"
            result="Islamabad - Remote"
            des="Developed the Zewst Phone app, enhancing order management and service ."
          />
          <ResumeCard
            title="Senior Software Engineer "
            subTitle="Techdots - (Sep 2023 - Dec 2023)"
            result="Lahore - Onsite"
            des="Existing app for customer services providing Contributed to high-profile projects."
          />
          <ResumeCard
            title="Senior Software Engineer "
            subTitle="Supersoft Technology  - (Jul 2023 - Sep 2023)"
            result="Karachi - Onsite"
            des="E-Commerce Mobile application and website ."
          />

          <ResumeCard
            title=" Software Engineer "
            subTitle="Crov-Technology   - (Dec 2022 - Jul 2023)"
            result="Lahor - Remote"
            des="React Native mobile apps Customer app and Beautician P2P ."
          />
          <ResumeCard
            title="Software Engineer "
            subTitle="Appsware-Technology   - (Aug 2019 - 2022)"
            result="Karachi - Onsite"
            des="I start my journey mobile apps development for mobile apps."
          />
        </div>
      </div>
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]"></p>
          <h2 className="text-3xl md:text-4xl font-bold">Education</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Master of Information Technology "
            subTitle="Virtual University Karachi (VUKHI01)"
            result="Karachi"
            des="Completed with first division covered IT subjects with practices "
          />
          <ResumeCard
            title="Bachelor of computer science :"
            subTitle="University of Sindh Jamshoro "
            result="Hydrabad"
            des="Completed with first division covered Computer science subjects with practices"
          />
          <ResumeCard
            title="Intermediate: (FSC)"
            subTitle="Hyderabad Board "
            result="Hydrabad"
            des="Completed with first division covered Sciense subjects with practices"
          />
          <ResumeCard
            title="Matriculation: (Science)"
            subTitle="Hyderabad Board "
            result="Hydrabad"
            des="Completed with first division All subjects with practices"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
